import { Link } from 'react-router-dom';
import { COLORS } from 'shared/consts';
import styled, { css } from 'styled-components';

export const DesktopHudWrap = styled.nav<{$collapsed?: boolean}>`
  width: 240px;
  height: 100%;
  max-height: 100dvh;
  overflow-y: auto;
  overflow-x: clip;
  display: flex;
  padding: 8px 0;
  flex-direction: column;
  position: relative;
  background: #fff;
  border-right: 1px solid ${COLORS.BORDER.SOFT};
  background: ${COLORS.BG.PAGE_FILLED};
  scrollbar-width: thin;
    z-index: 2000;
    
  ${({$collapsed}) => 
      $collapsed ? css`width: 48px; scrollbar-width: none;`
      : css``        
  }
`;

export const DesktopHudTop = styled.div<{$collapsed?: boolean}>`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-inline: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    ${({$collapsed}) =>
            $collapsed ? css`padding: 16px 4px;`
                    : css``
    }
`

export const DesktopHudMiddle = styled.div<{$collapsed?: boolean}>`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
    padding: 8px 16px;
    ${({$collapsed}) =>
            $collapsed ? css`padding: 8px 4px;`
                    : css``
    }
`

export const DesktopOtherButtonWrapper = styled.div`
    position: relative;
    width: 100%;
    > * {
        width: 100%;
    }
`

export const DesktopAddButtonWrapper = styled.div<{$collapsed?: boolean}>`
    margin-top: 12px;
    width: 100%;
    
    > * {
        width: 100%;
    }

    .button.button--primary.button--accent svg {
        fill: transparent!important;
    }
    ${({$collapsed}) =>
            $collapsed ? css`width: 36px; margin: 20px auto 0;`
                    : css``
    }
`


export const DesktopHudBottom = styled.div<{$collapsed?: boolean}>`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 8px 16px;
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    ${({$collapsed}) =>
            $collapsed ? css`padding: 8px 4px;`
                    : css``
    }
`

export const DesktopHudLogo = styled(Link)<{$collapsed?: boolean}>`
  display: flex;
  padding: 8px;
  gap: 12px;
  align-items: center;
  margin: 0 4px 12px;
    
    ${({$collapsed}) =>
            $collapsed ? css`padding: 0; gap: 0; margin: 0 4px 20px; width: 32px; height: 32px; > svg {width: 100%; height: 100%;}`
                    : css``
    }
    
`

export const DesktopHudTitle = styled.h2`
    color: ${COLORS.FG.DEFAULT};
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
`

export const MobileHeaderWrapper = styled.div<{ $hidden?: boolean; $bg?: string; }>`
    width: 100%;
    position: fixed;
    display: flex;
    justify-content: space-between;
    height: 56px;
    padding-inline: 16px;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 10;

    transform: translateY(0);
    transition: transform 220ms ease-in-out;
    will-change: transform;
    background-color: ${props => props.$bg || COLORS.BG.PAGE};

    ${({ $hidden }) =>
            $hidden &&
            css`
      transform: translateY(-100%);
    `}
`;

export const MobileHeaderIconContainer = styled.div`
    width: 24px;
    height: 24px;
    > * {
        width: 100%;
        height: 100%;
    }
`;

export const MobileBottomWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 56px;
    padding: 4px;
    background: ${COLORS.BG.PAGE};
    z-index: 10;
    border-top: 1px solid ${COLORS.BORDER.MUTED};
`

export const DesktopFixedAddButton = styled.div`
    width: 48px;
    height: 48px;
    position: fixed;
    right: 16px;
    bottom: 81px;
    z-index: 11;
`
